module.exports = __webpack_public_path__ + "01f43047/img/dollar-icon.35c9d638.svg";